import { render, staticRenderFns } from "./job-setup-main.component.vue?vue&type=template&id=13335a52&scoped=true"
import script from "./job-setup-main.component.ts?vue&type=script&lang=ts&external"
export * from "./job-setup-main.component.ts?vue&type=script&lang=ts&external"
import style0 from "./job-setup-main.component.vue?vue&type=style&index=0&id=13335a52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13335a52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13335a52')) {
      api.createRecord('13335a52', component.options)
    } else {
      api.reload('13335a52', component.options)
    }
    module.hot.accept("./job-setup-main.component.vue?vue&type=template&id=13335a52&scoped=true", function () {
      api.rerender('13335a52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/job-setup/job-setup-main/job-setup-main.component.vue"
export default component.exports